import type { Mentor } from "@/entities/mentor/model";
import type { Student } from "@/pages/restricted/mentor/students-page/model";

export enum MentorshipType {
  MANUAL = "manual",
  AUTO = "auto",
}

export enum MentorshipStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export interface MentorshipNetIncome {
  mentor: number;
  student: number;
}

export interface Mentorship {
  _id: string;
  mentor: Mentor;
  student: Student;
  type: MentorshipType;
  status: MentorshipStatus;
  grossIncome: number;
  netIncome: MentorshipNetIncome;
  closedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}
